// src/components/plaid/PlaidConsentRow.jsx
import React, { useState } from "react";

// The consent row the link flow shows before Plaid Link (label and why from
// the consent catalog, never written here). Moved from
// intake/bodies/PlaidPanel.jsx (SP4) unchanged, for every link entry.
export default function PlaidConsentRow({ row, onConsent, idPrefix }) {
  // Controlled: a failed consent write unticks the box so it can be retried.
  const [on, setOn] = useState(false);
  return (
    <div className="tw-grid tw-gap-1 tw-rounded-lg tw-border tw-border-solid tw-border-divider tw-bg-surface tw-px-4 tw-py-3">
      <label className="tw-m-0 tw-flex tw-min-h-11 tw-items-center tw-gap-3 tw-text-sm tw-font-semibold">
        <input
          type="checkbox"
          className="tw-h-5 tw-w-5 tw-shrink-0 tw-accent-text-accent"
          aria-describedby={`${idPrefix}-consent-why`}
          checked={on}
          onChange={async (e) => {
            if (!e.target.checked) return;
            setOn(true);
            if ((await onConsent()) === false) setOn(false);
          }}
        />
        {row.label}
      </label>
      <p
        id={`${idPrefix}-consent-why`}
        className="tw-m-0 tw-text-sm tw-text-text-muted"
      >
        {row.why}
      </p>
    </div>
  );
}
